import React from "react";
import { RaddLogo2 } from "../../icons/icons";

const StartScreen = () => (
  <div className="loading-screen-page">
    <div className="loading-screen">
      <div className="loading-screen__logo">
        <RaddLogo2 />
      </div>
      <div className="loading-screen__title">Hold on!</div>
      <div className="loading-screen__subtitle">
        Your radd. stories are just about to load
      </div>
      <div className="loading-screen__container">
        <div className="loading-screen__outer-circle">
          <div className="loading-screen__inner-circle"></div>
        </div>
        <div className="loading-screen__small-circle first">
          <div className="loading-screen__small-inner blue"></div>
        </div>
        <div className="loading-screen__small-circle second">
          <div className="loading-screen__small-inner"></div>
        </div>
        <div className="loading-screen__small-circle third">
          <div className="loading-screen__small-inner"></div>
        </div>
      </div>
    </div>
  </div>
);

export default StartScreen;
